// src/store/useAppStore.js
import { create } from 'zustand';

const persisted = (key, initial) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return initial;
    return JSON.parse(raw);
  } catch { return initial; }
};

export const useAppStore = create((set, get) => ({
  // тема
  theme: localStorage.getItem('theme') || 'light',
  setTheme: (name) => { localStorage.setItem('theme', name); set({ theme: name }); },
  setThemeFromStorage: () => set({ theme: localStorage.getItem('theme') || 'light' }),

  // язык
  lang: localStorage.getItem('lang') || 'ru',
  setLang: (lng) => { localStorage.setItem('lang', lng); set({ lang: lng }); },

  // выбранный регион (влияет на главную)
  regionId: (()=>{ const v = localStorage.getItem('region_id'); return v ? Number(v) : ''; })(),
  regionName: localStorage.getItem('region_name') || '',
  regionSlug: localStorage.getItem('region_slug') || '',
  regionCode: localStorage.getItem('region_code') || '',
  setRegion: (id, name='', slug='', code='') => {
    const val = (id==='' || id==null) ? '' : Number(id);
    try { localStorage.setItem('region_id', String(val||'')); } catch {}
    try { localStorage.setItem('region_name', name||''); } catch {}
    try { localStorage.setItem('region_slug', slug||''); } catch {}
    try { localStorage.setItem('region_code', code||''); } catch {}
    set({ regionId: val||'', regionName: name||'', regionSlug: slug||'', regionCode: code||'' });
  },

  // избранное
  favorites: persisted('favorites', []),
  toggleFavorite: (id) => {
    const cur = get().favorites || [];
    const next = cur.includes(id) ? cur.filter(x=>x!==id) : [...cur, id];
    localStorage.setItem('favorites', JSON.stringify(next));
    set({ favorites: next });
  },
}));
